import cloneDeep from 'lodash.clonedeep';

import {
  getDefaultProjectDataPrefix,
  getDefaultProjectModelPrefix,
} from 'src/containers/ProjectDiagram/utils/generateProjectIri';
import { Project } from 'src/store/state/projects';

export const duplicateProject = (
  project: Project,
  newProperties: { id: string } & Partial<Project>
): Project => {
  const { id: newId, ...propertiesToUpdate } = newProperties;
  const newProject = cloneDeep(project);
  const datestamp = Date.now();

  newProject.id = newId;
  newProject.dateCreated = datestamp;
  newProject.dateLastUpdated = datestamp;

  newProject.modelNamespace =
    propertiesToUpdate.modelNamespace || getDefaultProjectModelPrefix(project);
  newProject.dataNamespace =
    propertiesToUpdate.dataNamespace || getDefaultProjectDataPrefix(project);

  newProject.diagram = cloneDeep(project.diagram);

  return { ...newProject, ...propertiesToUpdate };
};
